import * as React from "react"
import * as ReactDOM from "react-dom"
import i18next from "./locale/i18next"
import * as Sentry from "@sentry/react"
import "rsuite/dist/styles/rsuite-default.css"
import { ConfigProvider, App as AppAntd } from "antd"
import { AntdLangContext } from "commons/AntdLangContext"
import { RSuiteLangContext } from "commons/RSuiteLangContext"

import App from "./App"
import "asset/scss/index.scss"
import { theme } from "./theme"
import "asset/fonts/Roboto/index.scss"
import "asset/fonts/SF-Pro-Text/index.scss"
import { contextApp } from "commons/Context"
import { Functions } from "commons/Functions"
import { SentryConfig } from "../sentry.config"
import { AgentProvider } from "hooks/agent"
import { AppCtxProvider } from "./context/provider/AppCtxProvider"

const root: any = document.getElementById("root")

let data = {
	id: root.dataset.id,
	timeline: root.dataset.timeline,
}

export const Context = ({ data }: any) => {
	const [context, setContext] = React.useState()

	return (
		<contextApp.Provider value={{ context, setContext }}>
			<AppCtxProvider>
				<App data={data} />
			</AppCtxProvider>
		</contextApp.Provider>
	)
}

if (!Functions.isInDevelopment()) Sentry.init(SentryConfig)

ReactDOM.render(
	<React.StrictMode>
		<AgentProvider i18n={i18next}>
			<ConfigProvider theme={theme}>
				<AppAntd>
					<RSuiteLangContext>
						<AntdLangContext>
							<script
								type="text/javascript"
								src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment.min.js"
							></script>
							<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/es.js"></script>
							<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/pt.js"></script>
							<Context data={data} />
						</AntdLangContext>
					</RSuiteLangContext>
				</AppAntd>
			</ConfigProvider>
		</AgentProvider>
	</React.StrictMode>,
	root
)
